import { render, staticRenderFns } from "./PayPalSubscription.vue?vue&type=template&id=5324f19d&"
import script from "./PayPalSubscription.vue?vue&type=script&lang=js&"
export * from "./PayPalSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports